/* KraftCover — Kademeli Ödül Dönemi drawer katmanı.
   Konfig: window.kcKampanya (shop metafield custom.kc_kampanya).
   Para tarafının tek doğrusu Shopify Discount Function'dır (kc-kademe-discount);
   buradaki her hesap yalnızca GÖSTERİM içindir ve Function'la aynı kurallara uyar:
   hediye/VIP/istisna satırları eşiğe sayılmaz. Tutarlar kuruş cinsindendir.
   Nöro kurallar: kazanç yukarı sayarken animasyonlu, AŞAĞI İNERKEN SESSİZ (panik yok);
   hedef asla gizlenmez; ilk kilit kutlaması büyük, tekrarlar kompakt; zirve kapanmaz. */
(function () {
  'use strict';
  var CFG = window.kcKampanya;
  if (!CFG || !CFG.aktif) return;
  // Test kolaylığı: ?kckpop=reset ile seans bayrağı sıfırlanır
  if (location.search.indexOf('kckpop=reset') !== -1) sessionStorage.removeItem('kck_popup');

  var GIFT_PROPS = ['_kc_gift', '_kc_gift2', '_kc_gift3', '_kc_vip30'];
  // Kasım 2026 'hediye' modu: yalnız eşikli aynı-ürün hediyeleri (yüzde/VIP/popup yok)
  var HMOD = CFG.mod === 'hediye';
  function hNo(etiket) { return etiket === '_kc_gift3' ? 3 : (etiket === '_kc_gift2' ? 2 : 1); }
  // Süre dolduysa katman tamamen susar (sayfa açık kalsa bile)
  if (CFG.bitis && Date.now() > new Date(CFG.bitis).getTime()) return;
  if (CFG.baslangic && Date.now() < new Date(CFG.baslangic).getTime()) return;
  var HYSTERESIS = 10000;      // 100 TL: eşik altına inişte marj olmadan hediyeyi geri alma
  var NEAR_MISS = 40000;       // 400 TL: "neredeyse açık" eşiği
  var busy = false;
  var debounceTimer = null;
  var lastTierKey = null;      // null = ilk gözlem (hoş-geldin toast'ı buradan)
  var lastKazanc = 0;

  function tl(cents) {
    return (cents / 100).toLocaleString('tr-TR', { maximumFractionDigits: 0 }) + ' TL';
  }

  function lineTag(item) {
    if (!item.properties) return null;
    for (var i = 0; i < GIFT_PROPS.length; i++) {
      if (item.properties[GIFT_PROPS[i]]) return GIFT_PROPS[i];
    }
    return null;
  }

  /* ===== HEDİYE RENK SEÇİMİ (03.08) =====
     Konfig: hediye_kademeler[].renkler = [{ad, hex, variant_numeric}].
     Seçim sessionStorage'da tutulur — revocation sonrası hediye geri gelirken
     müşterinin rengi korunur. Para tarafı: Function whitelist (varyantlar). */
  function kademeOf(etiket) {
    return (CFG.hediye_kademeler || []).filter(function (h) { return h.etiket === etiket; })[0] || null;
  }
  function renkPref(etiket) {
    var v = parseInt(sessionStorage.getItem('kck_renk' + etiket), 10);
    return isNaN(v) ? 0 : v;
  }
  /* Eklenecek varyant sırası: tercih → varsayılan → kalan renkler.
     Stok bitiğinde add.js reddeder; sıradaki aday denenir (Rope Turuncu stok 12!). */
  function giftAdaylar(h) {
    var ids = [];
    var renkler = (h.renkler || []).map(function (r) { return r.variant_numeric; });
    var pref = renkPref(h.etiket);
    if (pref && renkler.indexOf(pref) !== -1) ids.push(pref);
    if (ids.indexOf(h.variant_numeric) === -1) ids.push(h.variant_numeric);
    renkler.forEach(function (v) { if (ids.indexOf(v) === -1) ids.push(v); });
    return ids;
  }

  /* Function'daki sınıflandırmanın aynası */
  function analyze(cart) {
    var qualifying = 0;
    var gifts = {};
    (cart.items || []).forEach(function (item) {
      var tag = lineTag(item);
      if (tag) { gifts[tag] = item; return; }
      if (CFG.istisna_numeric && CFG.istisna_numeric.indexOf(item.product_id) !== -1) return;
      qualifying += item.original_line_price; // HAM fiyat — Function'ın subtotalAmount'ıyla aynı taban
    });

    var tiers = [];
    (CFG.hediye_kademeler || []).forEach(function (h) {
      tiers.push({ esik: h.esik * 100, tip: 'hediye', etiket: h.etiket, deger: h.deger_tl * 100 });
    });
    (CFG.yuzde_kademeler || []).forEach(function (y) {
      tiers.push({ esik: y.esik * 100, tip: 'yuzde', yuzde: y.yuzde });
    });
    if (CFG.vip) tiers.push({ esik: CFG.vip.esik * 100, tip: 'vip', yuzde: CFG.vip.yuzde });
    tiers.sort(function (a, b) { return a.esik - b.esik; });

    var activeYuzde = 0;
    (CFG.yuzde_kademeler || []).forEach(function (y) {
      if (qualifying >= y.esik * 100 && y.yuzde > activeYuzde) activeYuzde = y.yuzde;
    });

    var kazanc = Math.round(qualifying * activeYuzde / 100);
    (CFG.hediye_kademeler || []).forEach(function (h) {
      if (qualifying >= h.esik * 100) kazanc += h.deger_tl * 100;
    });

    var next = null;
    for (var i = 0; i < tiers.length; i++) {
      if (qualifying < tiers[i].esik) { next = tiers[i]; break; }
    }

    var unlocked = 0;
    tiers.forEach(function (t) { if (qualifying >= t.esik) unlocked++; });

    var vipEsik = CFG.vip ? CFG.vip.esik * 100 : Infinity;
    var vipAcik = qualifying >= vipEsik && !gifts['_kc_vip30'];
    var vipKullanildi = !!gifts['_kc_vip30'];

    return { qualifying: qualifying, tiers: tiers, activeYuzde: activeYuzde, kazanc: kazanc,
             next: next, gifts: gifts, unlocked: unlocked, vipAcik: vipAcik, vipKullanildi: vipKullanildi };
  }

  function tierLabel(t) {
    if (t.tip === 'yuzde' || t.tip === 'vip') return '%' + t.yuzde;
    if (HMOD) return hNo(t.etiket) + ' Hediye';
    return t.etiket === '_kc_gift2' ? 'Sürpriz' : 'Hediye';
  }

  /* ===== RETRO LOADER (B varyantı, 30.07 onaylı) =====
     Checkpoint rozetleri: ✓ geçildi (siyah), yanıp sönen hedef (turuncu), kilitli (gri).
     Rozetler iki seviyede dizilir (dar ekranda Hediye/%15 çakışmasın). */
  function mileLabel(t) {
    return tierLabel(t).toLocaleUpperCase('tr-TR');
  }
  /* Duraklar EŞİT ARALIKLI dizilir (03.08): oransal yerleşimde 2.200/2.750
     çipleri çakışıp "%15 alınmış" yanılsaması yaratıyordu. Dolgu da duraklar
     arası parça-parça doğrusal → bar görüntüsü "X TL kaldı" satırıyla tutarlı. */
  function mileStops(tiers) {
    var n = tiers.length || 1;
    return tiers.map(function (t, i) {
      return { esik: t.esik, pct: Math.round((i + 1) * 100 / (n + 0.4)) };
    });
  }
  function fillPctOf(qualifying, tiers) {
    var stops = mileStops(tiers);
    if (!stops.length) return 0;
    var prevE = 0, prevP = 0;
    for (var i = 0; i < stops.length; i++) {
      if (qualifying < stops[i].esik) {
        return Math.round(prevP + (qualifying - prevE) * (stops[i].pct - prevP) / (stops[i].esik - prevE));
      }
      prevE = stops[i].esik; prevP = stops[i].pct;
    }
    return 100; // zirve geçildi: bar tam dolu
  }
  function milesHtml(tiers, isDone, isNew, markAll) {
    var stops = mileStops(tiers);
    var nextFound = false;
    var html = '';
    // Mockup B birebir: geçilen ✓ siyah, SADECE sıradaki hedef yanıp söner, gerisi gri.
    tiers.forEach(function (t, idx) {
      var left = stops[idx].pct;
      var done = isDone(t);
      var yeni = !done && isNew(t) && !nextFound;
      if (yeni) nextFound = true;
      var cls = 'kck-mile' + (idx % 2 ? ' lvl2' : '') + (done ? ' done' : (yeni ? ' next' : ''));
      html += '<div class="' + cls + '" style="left:' + left + '%">' + (done ? '<i>✓</i>' : '') + mileLabel(t) + '</div>';
    });
    return html;
  }

  /* Terminal alt satırı: sol hedef, sağ kalan tutar */
  function footHtml(st) {
    if (HMOD) {
      if (!st.next) return '<div class="kck-ldr__foot"><span>&gt; 3 hediyenin hepsi senin</span><span class="r">tamam<u>_</u></span></div>';
      return '<div class="kck-ldr__foot"><span>&gt; hedef: ' + hNo(st.next.etiket) + '. hediye</span><span class="r">' + tl(st.next.esik - st.qualifying) + ' kaldı<u>_</u></span></div>';
    }
    if (!st.next) {
      if (st.vipAcik && !st.gifts['_kc_vip30'] && CFG.vip) {
        // SEÇ = seçim modunu kur + anasayfaya git: eklediği İLK ürün otomatik %30
        // etiketiyle girer (fetch patch'i aşağıda; para doğrulaması Function'da)
        return '<div class="kck-ldr__foot"><span>&gt; zirvedesin</span>' +
          '<a class="r kck-vip-sec" href="/">%' + CFG.vip.yuzde + '\'luk ürününü seç →</a></div>';
      }
      // "tüm ödüller açık" = "alışveriş bitti" okunuyordu (04.08): zirvede bile
      // her eklenen ürün sepet %'siyle kazandırıyor — marjinal teşvik konuşsun
      var zy = st.activeYuzde || (CFG.yuzde_kademeler && CFG.yuzde_kademeler.length ? CFG.yuzde_kademeler[CFG.yuzde_kademeler.length - 1].yuzde : 20);
      return '<div class="kck-ldr__foot"><span>&gt; zirvedesin</span><span class="r">her yeni ürün %' + zy + ' indirimli<u>_</u></span></div>';
    }
    var kalan = tl(st.next.esik - st.qualifying);
    var ad;
    if (st.next.tip === 'hediye' && st.next.etiket === '_kc_gift') ad = 'hediye';
    else if (st.next.tip === 'hediye') ad = 'sürpriz hediye';
    else if (st.next.tip === 'vip') ad = 'zirve — dilediğin ürün %' + st.next.yuzde;
    else ad = '%' + st.next.yuzde + ' indirim';
    return '<div class="kck-ldr__foot"><span>&gt; hedef: ' + ad + '</span><span class="r">' + kalan + ' kaldı<u>_</u></span></div>';
  }

  /* Kazanç sayacı: sadece YUKARI animasyon (600ms), aşağı sessiz */
  function animateKazanc(el, from, to) {
    var start = null;
    function step(ts) {
      if (!start) start = ts;
      var p = Math.min(1, (ts - start) / 600);
      var eased = 1 - Math.pow(1 - p, 3);
      el.textContent = tl(Math.round(from + (to - from) * eased));
      if (p < 1) requestAnimationFrame(step);
    }
    requestAnimationFrame(step);
  }

  /* ===== MOBİL METER — VARYANT A "Tek Nefes" (04.08 onaylı mockup) =====
     ≤640px'te rozetli 2 seviyeli meter yerine: kazanç + sıradaki-hedef çipi
     + ince bar + etiketsiz 5 nokta (~70px). Masaüstü ve PDP modülü DEĞİŞMEZ —
     ikisi de aynı analyze()'den beslenir, rakamlar her zaman aynıdır. */
  function kisaAd(t) {
    if (t.tip === 'yuzde' || t.tip === 'vip') return '%' + t.yuzde;
    if (HMOD) return hNo(t.etiket) + '. HEDİYE';
    return t.etiket === '_kc_gift2' ? 'SÜRPRİZ' : 'HEDİYE';
  }
  function mobilMeterHtml(st) {
    if (st.kazanc <= 0) {
      var ilk = null;
      for (var i = 0; i < st.tiers.length; i++) {
        if (st.qualifying < st.tiers[i].esik) { ilk = st.tiers[i]; break; }
      }
      var sag = ilk ? 'İlki ' + tl(ilk.esik - st.qualifying) + ' sonra →' : '';
      return '<div class="kck-ma kck-ma--bos"><span>' + (HMOD ? 'Hediye keyring seni bekliyor' : st.tiers.length + ' ödül seni bekliyor') + '</span><u>' + sag + '</u></div>';
    }
    var sagHtml;
    if (!st.next) {
      if (HMOD) {
        sagHtml = '<span class="kck-ma__next"><b>3 hediye senin</b></span>';
      } else if (st.vipAcik && CFG.vip) {
        sagHtml = '<a class="kck-ma__sec kck-vip-sec" href="/">%' + CFG.vip.yuzde + '\'luk ürününü seç →</a>';
      } else {
        var zyM = st.activeYuzde || 20;
        sagHtml = '<span class="kck-ma__next">her yeni ürün <b>%' + zyM + '</b></span>';
      }
    } else {
      sagHtml = '<span class="kck-ma__next">' + kisaAd(st.next) + ' · <b>' + tl(st.next.esik - st.qualifying) + ' kaldı</b></span>';
    }
    var stops = mileStops(st.tiers);
    var dots = st.tiers.map(function (t, i) {
      var done = st.qualifying >= t.esik;
      var nx = !done && st.next && st.next.esik === t.esik && st.next.tip === t.tip;
      return '<span class="kck-ma__dot' + (done ? ' done' : (nx ? ' next' : '')) + '" style="left:' + stops[i].pct + '%"></span>';
    }).join('');
    return '<div class="kck-ma">' +
      '<div class="kck-ma__top">' +
        '<span class="kck-ma__kaz"><span class="kck-ma__num" id="kck-big-num">' + tl(st.kazanc) + '</span><i>kazandın</i></span>' +
        sagHtml +
      '</div>' +
      '<div class="kck-ma__barwrap">' +
        '<div class="kck-ma__bar"><div class="kck-ma__fill" style="width:' + fillPctOf(st.qualifying, st.tiers) + '%"></div></div>' +
        '<div class="kck-ma__dots">' + dots + '</div>' +
      '</div>' +
    '</div>';
  }

  /* ===== METER ===== */
  function renderMeter(cart) {
    var ship = document.getElementById('tb-ship');
    if (!ship) return;
    var st = analyze(cart);

    var host = document.getElementById('kck-meter');
    if (!host) {
      host = document.createElement('div');
      host.id = 'kck-meter';
      host.className = 'kck-meter';
      if (HMOD) ship.parentNode.insertBefore(host, ship.nextSibling);
      else ship.parentNode.insertBefore(host, ship);
    }
    if (!HMOD) ship.style.display = 'none';
    if (!cart.item_count) { host.style.display = 'none'; lastKazanc = 0; return; }
    host.style.display = '';

    if (window.matchMedia('(max-width: 640px)').matches) {
      host.innerHTML = mobilMeterHtml(st);
    } else {
      var fillPct = fillPctOf(st.qualifying, st.tiers);

      var miles = milesHtml(st.tiers,
        function (t) { return st.qualifying >= t.esik; },
        function (t) { return st.next && st.next.esik === t.esik && st.next.tip === t.tip; });

      var kazHtml = st.kazanc > 0
        ? '<div class="kck-ldr__kaz"><span id="kck-big-num">' + tl(st.kazanc) + '</span><i>kazandın</i></div>'
        : '<div class="kck-ldr__kaz kck-ldr__kaz--zero">' + (HMOD ? tl(st.tiers[0].esik - st.qualifying) + ' sonra hediye keyring' : '5 ödül seni bekliyor') + '</div>';

      host.innerHTML =
        '<div class="kck-ldr__t">' + (HMOD ? 'HEDİYE YÜKLENİYOR' : 'KAZANÇ YÜKLENİYOR') + '<span class="kck-dots"><i>.</i><i>.</i><i>.</i></span></div>' +
        kazHtml +
        '<div class="kck-ldr__wrap">' + miles +
          '<div class="kck-ldr__bar"><div class="kck-ldr__fill" style="width:' + fillPct + '%"></div></div>' +
        '</div>' +
        footHtml(st);
    }

    // Yukarı sayaç + accent flash; aşağıda sessiz
    if (st.kazanc > lastKazanc && lastKazanc >= 0) {
      var numEl = document.getElementById('kck-big-num');
      if (numEl && lastKazanc > 0) {
        animateKazanc(numEl, lastKazanc, st.kazanc);
      }
      if (numEl) {
        numEl.classList.remove('kck-flash');
        void numEl.offsetWidth;
        numEl.classList.add('kck-flash');
      }
    }
    lastKazanc = st.kazanc;
  }

  /* ===== HEDİYE OTOMASYONU ===== */
  function syncGifts() {
    if (busy) return;
    busy = true;
    // Stale snapshot'a güvenme: plan HER ZAMAN taze /cart.js üstünden kurulur
    fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
      var st = analyze(cart);
      var jobs = [];

      // Aynı etiketten İKİNCİ satır silinir (renk swap'ı yarıda kalırsa oluşur).
      // cart.js item sırası: en yeni önce → İLK görülen (yeni renk) kalır, eskisi gider.
      // Function tarafında da aynası var: ikinci satır %100 almaz.
      var gorulen = {};
      (cart.items || []).forEach(function (item) {
        var tag = lineTag(item);
        if (!tag) return;
        if (gorulen[tag]) { jobs.push({ tip: 'rm', key: item.key }); return; }
        gorulen[tag] = true;
        if (item.quantity > 1) jobs.push({ tip: 'qty1', key: item.key });
      });

      (CFG.hediye_kademeler || []).forEach(function (h) {
        var esik = h.esik * 100;
        var has = !!st.gifts[h.etiket];
        if (!has && st.qualifying >= esik && h.variant_numeric) jobs.push({ tip: 'add', h: h });
        // HİSTEREZİS KALDIRILDI (06.08 acil): Function eşiğin ALTINDA %100 vermez.
        // Bantta satırı tutmak = drawer 0 TL derken checkout'un tam fiyat çekmesi.
        // Eşik sağlanmıyorsa etiketli hediye satırı sepette YAŞAYAMAZ.
        else if (has && st.qualifying < esik) jobs.push({ tip: 'rm', key: st.gifts[h.etiket].key });
      });

      if (CFG.vip && st.gifts['_kc_vip30'] && st.qualifying < CFG.vip.esik * 100 - HYSTERESIS) {
        // Plan kuralı: VIP düşünce ürün SİLİNMEZ, full fiyata döner (etiket temizlenir).
        // Müşterinin bilinçli seçtiği ürünü sepetten uçurmak = kayıp his + destek bileti. (QA FLAW-1)
        jobs.push({ tip: 'untag', key: st.gifts['_kc_vip30'].key });
      }

      if (CFG.test_urun_numeric) {
        // Test ürünü (10 TL "Sistem Kontrol") Function'ı test modunda tetikler —
        // gerçek ürünlerle BİRLİKTE sepette durması BİLİNÇLİ (para testi böyle yapılır).
        // Sadece tek başına kaldıysa (orphan) temizlenir.
        var gercekUrunVar = (cart.items || []).some(function (i) {
          return i.product_id !== CFG.test_urun_numeric && !lineTag(i);
        });
        var testItem = (cart.items || []).filter(function (i) { return i.product_id === CFG.test_urun_numeric; })[0];
        if (testItem && !gercekUrunVar) jobs.push({ tip: 'rm', key: testItem.key });
      }

      if (!jobs.length) { busy = false; return; }

      var chain = Promise.resolve();
      jobs.forEach(function (j) {
        chain = chain.then(function () {
          if (j.tip === 'add') {
            var props = {};
            props[j.h.etiket] = '1';
            // Adaylar sırayla: tercih edilen renk → varsayılan → kalanlar.
            // Stok reddi (422) sıradakini dener; hepsi biterse sessizce vazgeç.
            var adaylar = giftAdaylar(j.h);
            var deneme = Promise.reject();
            adaylar.forEach(function (vid) {
              deneme = deneme.catch(function () {
                return fetch('/cart/add.js', {
                  method: 'POST', headers: { 'Content-Type': 'application/json' },
                  body: JSON.stringify({ items: [{ id: vid, quantity: 1, properties: props }] })
                }).then(function (r) { if (!r.ok) throw 0; return r; });
              });
            });
            return deneme.catch(function () {});
          }
          if (j.tip === 'untag') {
            // Etiketi boş string'le ez (properties:{} Shopify'da yok sayılıyor) —
            // lineTag falsy değeri etiket saymaz → satır full fiyatlı normale döner
            return fetch('/cart/change.js', {
              method: 'POST', headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ id: j.key, quantity: 1, properties: { _kc_vip30: '' } })
            });
          }
          return fetch('/cart/change.js', {
            method: 'POST', headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: j.key, quantity: j.tip === 'qty1' ? 1 : 0 })
          });
        });
      });

      chain
        .then(function () { return fetch('/cart.js').then(function (r) { return r.json(); }); })
        .then(function (fresh) {
          busy = false; // busy ancak taze sepet ELDEyken bırakılır — çift-ekleme penceresi kapalı
          if (window.kcCartDrawer) window.kcCartDrawer.refreshFrom(fresh);
        })
        .catch(function (e) { busy = false; console.error('[kck] hediye senkron', e); });
    }).catch(function () { busy = false; });
  }

  /* ===== HEDİYE SATIRI GÖRÜNÜMÜ + SÜRPRİZ MASKESİ ===== */
  function decorateKademePrices(cart) {
    // Kazanılan sepet %'sini normal satırların fiyatına GÖRSEL dağıt (05.08 Hüseyin isteği).
    // Muhasebe DEĞİŞMEZ — Function checkout'ta aynı %'yi order-level basar; bu sadece drawer gösterimi.
    // Satır bazlı yuvarlama footer defterinden birkaç kuruş sapabilir — kabul (görsel katman).
    var kademeler = (CFG.yuzde_kademeler || []).slice().sort(function (a, b) { return b.esik - a.esik; });
    if (!kademeler.length) return;
    var qualifying = 0;
    (cart.items || []).forEach(function (i) {
      if (lineTag(i)) return;
      if (CFG.test_urun_numeric && i.product_id === CFG.test_urun_numeric) return;
      if (CFG.istisna_numeric && CFG.istisna_numeric.indexOf(i.product_id) !== -1) return;
      qualifying += i.original_line_price;
    });
    var pct = 0;
    for (var k = 0; k < kademeler.length; k++) {
      if (qualifying >= kademeler[k].esik * 100) { pct = kademeler[k].yuzde; break; }
    }
    if (pct <= 0) return; // % yok → drawer'ın kendi render'ı zaten ham/compare-at basıyor
    (cart.items || []).forEach(function (i) {
      if (lineTag(i)) return; // hediye/VIP satırlarının kendi gösterimi var
      if (CFG.test_urun_numeric && i.product_id === CFG.test_urun_numeric) return;
      if (CFG.istisna_numeric && CFG.istisna_numeric.indexOf(i.product_id) !== -1) return;
      if (i.properties && i.properties._bundle_label) return;
      var card = document.querySelector('.tb-card[data-key="' + i.key + '"]');
      if (!card) return;
      var priceEl = card.querySelector('.tb-card__prices');
      if (!priceEl) return;
      var indirimli = Math.round(i.original_line_price * (100 - pct) / 100);
      priceEl.innerHTML =
        '<span class="kck-won">' + tl(indirimli) + '</span>' +
        '<s class="tb-card__price tb-card__price--was">' + tl(i.original_line_price) + '</s>' +
        '<span class="kck-line-pct">sepette %' + pct + ' düştü</span>';
    });
  }

  function decorateGiftCards(cart) {
    (cart.items || []).forEach(function (item) {
      if (CFG.test_urun_numeric && item.product_id === CFG.test_urun_numeric) {
        var tcard = document.querySelector('.tb-card[data-key="' + item.key + '"]');
        if (tcard) tcard.style.display = 'none';
        return;
      }
      var tag = lineTag(item);
      if (!tag) return;
      var card = document.querySelector('.tb-card[data-key="' + item.key + '"]');
      if (!card || card.classList.contains('tb-card--kck-gift')) return;
      card.classList.add('tb-card--kck-gift');

      var nameEl = card.querySelector('.tb-card__name');
      var priceEl = card.querySelector('.tb-card__prices');
      if (HMOD && tag !== '_kc_vip30') {
        if (nameEl) nameEl.innerHTML = '<span class="kck-gift-tag">Hediyen' + (hNo(tag) > 1 ? ' · ' + hNo(tag) : '') + '</span><br>' + nameEl.textContent;
      } else if (tag === '_kc_gift2') {
        // Kazanma anı = açılış anı: ürün net görünür, gizem biter
        if (nameEl) nameEl.innerHTML = '<span class="kck-gift-tag">Sürprizin</span><br>' + nameEl.textContent;
      } else if (tag === '_kc_gift') {
        if (nameEl) nameEl.innerHTML = '<span class="kck-gift-tag">Hediyen</span><br>' + nameEl.textContent;
      }
      if (tag === '_kc_vip30') {
        if (nameEl) nameEl.innerHTML = '<span class="kck-gift-tag">Zirve — %' + (CFG.vip ? CFG.vip.yuzde : 30) + '</span><br>' + nameEl.textContent;
        if (priceEl && CFG.vip) {
          // Taban HAM fiyat (original_line_price): sepet %'si binmiş fiyattan strike gösterme —
          // kart ile footer defteri aynı rakamı söylesin (QA BUG-1, 30.07)
          var indirimli = Math.round(item.original_line_price * (100 - CFG.vip.yuzde) / 100);
          priceEl.innerHTML = '<s class="tb-card__price tb-card__price--was">' + tl(item.original_line_price) + '</s>' +
                              '<span class="kck-won">' + tl(indirimli) + '</span>';
        }
      } else if (priceEl) {
        // EMNİYET (06.08): Function %100 vermemişse (satır fiyatı > 0) ASLA "0 TL" yazma.
        // Yalancı UI = müşteriden hediye parası istemek. Gerçek fiyat kalır; syncGifts
        // eşik yoksa satırı zaten siler.
        if (item.final_line_price === 0) {
          priceEl.innerHTML = '<s class="tb-card__price tb-card__price--was">' + tl(item.original_line_price) + '</s>' +
                              '<span class="kck-won">0 TL</span>';
        }
      }

      // Renk swatch — hediye + sürpriz satırında (VIP hariç: müşteri ürünü kendi seçti)
      if (tag !== '_kc_vip30') {
        var kademe = kademeOf(tag);
        var renkler = (kademe && kademe.renkler) || [];
        if (renkler.length > 1) {
          var aktifAd = '';
          var dots = renkler.map(function (r) {
            var aktif = r.variant_numeric === item.variant_id;
            if (aktif) aktifAd = r.ad;
            return '<button type="button" class="kck-renk__dot' + (aktif ? ' is-on' : '') +
              '" style="--kck-c:' + r.hex + '" data-vid="' + r.variant_numeric +
              '" data-key="' + item.key + '" data-etiket="' + tag +
              '" aria-label="' + r.ad + '" title="' + r.ad + '"></button>';
          }).join('');
          var row = document.createElement('div');
          row.className = 'kck-renk';
          row.innerHTML = '<span class="kck-renk__l">Renk · <b id="kck-renk-ad-' + tag + '">' + aktifAd + '</b></span>' +
                          '<span class="kck-renk__dots">' + dots + '</span>';
          var info = card.querySelector('.tb-card__info');
          if (info) info.appendChild(row);
        }

        // Rope sürpriz kartı: değer kanıtı — uyum çipleri + spec satırı (karabiner kartı dili)
        if (tag === '_kc_gift2' && !HMOD) {
          var info2 = card.querySelector('.tb-card__info');
          if (info2 && !info2.querySelector('.kck-rope-info')) {
            // İkonlar karabiner kartıyla (cart-drawer.js _carabCardHTML) birebir aynı SVG'ler
            var tik = '<svg width="9" height="9" viewBox="0 0 24 24" fill="none" stroke="#1f9d55" stroke-width="3.5"><polyline points="20 6 9 17 4 12"/></svg>';
            var zincir = '<svg width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="#C4632E" stroke-width="2.4"><path d="M10 13a5 5 0 007 0l3-3a5 5 0 00-7-7l-1.5 1.5"/><path d="M14 11a5 5 0 00-7 0l-3 3a5 5 0 007 7l1.5-1.5"/></svg>';
            var ek = document.createElement('div');
            ek.className = 'kck-rope-info';
            ek.innerHTML =
              '<div class="kck-rope-uyum"><span class="l">Şunlarla uyumlu:</span>' +
                '<span class="kck-chip kck-chip--a">' + zincir + 'HEMEN HER ŞEYE</span>' +
                '<span class="kck-chip">' + tik + 'ROVE SLING</span>' +
                '<span class="kck-chip">' + tik + 'TERMOS</span>' +
                '<span class="kck-chip">' + tik + 'TELEFON ASKISI</span>' +
              '</div>' +
              '<div class="kck-rope-spec">9MM DAĞCILIK İPİ · DÜĞÜMLE AYARLANAN BOY</div>';
            info2.appendChild(ek);
          }
        }
      }
    });
  }

  /* Renk swap: yeni varyantı etiketiyle ekle → eskisini sil. Add başarısızsa
     (stok bitti) eski satır YERİNDE kalır, nokta "tükendi" işaretlenir.
     Ekle-önce-sil sırası bilinçli: yarıda kalırsa çift satır oluşur ama
     Function dedup'ı ikinciye %100 vermez, watchdog 4 sn'de temizler. */
  function renkSwap(dot) {
    if (busy) return;
    busy = true;
    var vid = parseInt(dot.getAttribute('data-vid'), 10);
    var key = dot.getAttribute('data-key');
    var etiket = dot.getAttribute('data-etiket');
    // Anında görsel tepki (swap birkaç saniye sürüyor — kullanıcı "oldu mu?" dememeli):
    // noktada dönen halka, kalan noktalar kilitli-sönük, renk adı hemen YENİ ada döner,
    // ürün görseli soluklaşır. Başarısızlıkta hepsi geri alınır.
    var row = dot.closest('.kck-renk');
    var card = dot.closest('.tb-card');
    var labelB = row ? row.querySelector('.kck-renk__l b') : null;
    var eskiAd = labelB ? labelB.textContent : '';
    // Görsel soluklaştırma: temada img'e opacity !important basan bir kural var
    // (CORS'lu sheet, adı okunamıyor) — sıradan inline bile yeniliyor.
    // Tek kazanan: inline + important.
    var cardImg = card ? card.querySelector('.tb-card__img img') : null;
    if (row) row.classList.add('is-swap');
    if (card) card.classList.add('is-kck-swap');
    // NOT: inline transition + important opacity birlikte Chrome'da hiç uygulanmıyor
    // (canlıda tespit, 03.08) — transition YOK, soluklaşma anında. Zaten daha iyi feedback.
    if (cardImg) cardImg.style.setProperty('opacity', '.45', 'important');
    if (labelB) labelB.textContent = dot.getAttribute('aria-label');
    dot.classList.add('is-bekle');
    function geriAl() {
      dot.classList.remove('is-bekle');
      if (row) row.classList.remove('is-swap');
      if (card) card.classList.remove('is-kck-swap');
      if (cardImg) cardImg.style.removeProperty('opacity');
      if (labelB) labelB.textContent = eskiAd;
    }
    var props = {};
    props[etiket] = '1';
    fetch('/cart/add.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [{ id: vid, quantity: 1, properties: props }] })
    }).then(function (r) {
      if (!r.ok) {
        geriAl();
        dot.classList.add('is-yok');
        dot.title = dot.getAttribute('aria-label') + ' — tükendi';
        throw 'tukendi';
      }
      sessionStorage.setItem('kck_renk' + etiket, String(vid));
      return fetch('/cart/change.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: key, quantity: 0 })
      });
    }).then(function () {
      return fetch('/cart.js').then(function (r) { return r.json(); });
    }).then(function (fresh) {
      busy = false;
      // refreshFrom drawer'ı yeniden çizer — bekleme durumları DOM'la birlikte gider
      if (window.kcCartDrawer) window.kcCartDrawer.refreshFrom(fresh);
    }).catch(function (e) { busy = false; if (e !== 'tukendi') geriAl(); });
  }

  function hookRenkSwatch() {
    document.addEventListener('click', function (ev) {
      var dot = ev.target.closest('.kck-renk__dot');
      if (!dot || dot.classList.contains('is-on') || dot.classList.contains('is-yok')) return;
      ev.preventDefault();
      ev.stopPropagation();
      renkSwap(dot);
    }, true);
  }

  /* ===== VIP SEÇİM MODU =====
     Meter'daki "%30'luk ürününü seç →" → mod kurulur + anasayfaya gider.
     Mod açıkken sepete eklenen İLK ürün otomatik _kc_vip30 etiketiyle girer
     (tek adet), mod düşer. Para tarafı Function'da doğrulanır: eşik yoksa
     etiket hiçbir şey kazandırmaz — suistimal kapalı. Hediye/etiketli
     otomasyon add'leri (syncGifts, renkSwap) atlanır. */
  var VIP_SEC_KEY = 'kck_vip_sec';
  function vipSecArmed() { return sessionStorage.getItem(VIP_SEC_KEY) === '1'; }
  function vipSecDisarm() { sessionStorage.removeItem(VIP_SEC_KEY); sessionStorage.removeItem('kck_vip_sec_t'); }

  function hookVipSec() {
    document.addEventListener('click', function (ev) {
      var a = ev.target.closest('.kck-vip-sec');
      if (!a) return;
      sessionStorage.setItem(VIP_SEC_KEY, '1');
      sessionStorage.removeItem('kck_vip_sec_t'); // varış sayfasında bilgi toast'ı çıksın
    }, true);

    // Tüm add yolları (PDP form=FormData, hızlı ekle/popup=JSON) window.fetch'ten
    // geçiyor (tb-drawer hijack) — tek patch noktası
    var origFetch = window.fetch;
    window.fetch = function (url, opts) {
      var etiketlendi = false;
      try {
        if (vipSecArmed() && typeof url === 'string' && url.indexOf('/cart/add') !== -1 && opts && opts.body) {
          var st = window.__kckLastCart ? analyze(window.__kckLastCart) : null;
          if (st && st.vipAcik) {
            if (typeof opts.body === 'string') {
              var body = JSON.parse(opts.body);
              var items = body.items || [body];
              var uygun = items.length && !items.some(function (it) {
                var p = it.properties || {};
                return p._kc_gift || p._kc_gift2 || p._kc_vip30;
              });
              if (uygun) {
                items[0].properties = items[0].properties || {};
                items[0].properties._kc_vip30 = '1';
                items[0].quantity = 1;
                opts.body = JSON.stringify(body);
                etiketlendi = true;
              }
            } else if (opts.body instanceof FormData) {
              var fd = opts.body;
              if (!fd.get('properties[_kc_gift]') && !fd.get('properties[_kc_gift2]') && !fd.get('properties[_kc_vip30]')) {
                fd.set('properties[_kc_vip30]', '1');
                fd.set('quantity', '1');
                etiketlendi = true;
              }
            }
            if (etiketlendi) vipSecDisarm();
          }
        }
      } catch (e) { console.error('[kck] vip seç', e); }
      var sonuc = origFetch.apply(this, arguments);
      if (etiketlendi) {
        // Add BAŞARISIZSA (stok/varyant hatası) hak yanmasın — modu geri kur
        sonuc = sonuc.then(function (res) {
          if (!res.ok) sessionStorage.setItem(VIP_SEC_KEY, '1');
          return res;
        });
      }
      return sonuc;
    };
  }

  /* ===== TOAST — dopamin pacing: ilk büyük, tekrarlar kompakt, dönüş hoş-geldin ===== */
  function showToast(variant, title, big, detail, ms) {
    var el = document.getElementById('kck-toast');
    if (!el) {
      el = document.createElement('div');
      el.id = 'kck-toast';
      document.body.appendChild(el);
    }
    el.className = 'kck-toast kck-toast--' + variant;
    el.innerHTML =
      '<div class="kck-toast__t">' + title + '</div>' +
      (big ? '<div class="kck-toast__big">' + big + '<i>toplam kazancın</i></div>' : '') +
      (detail ? '<div class="kck-toast__d">' + detail + '</div>' : '');
    void el.offsetWidth;
    el.classList.add('is-in');
    clearTimeout(el._t);
    el._t = setTimeout(function () { el.classList.remove('is-in'); }, ms);
  }

  function nextStopText(st) {
    if (HMOD) {
      if (!st.next) return '<b>3 hediyenin hepsi sepetinde.</b>';
      return 'Sıradaki: <b>' + hNo(st.next.etiket) + '. hediye — ' + tl(st.next.esik - st.qualifying) + ' sonra.</b>';
    }
    if (!st.next) return '<b>Dilediğin ürün %30 — ve her yeni ürün %' + (st.activeYuzde || 20) + ' kazandırmaya devam eder.</b>';
    var ad;
    if (st.next.tip === 'yuzde') ad = '%' + st.next.yuzde;
    else if (st.next.tip === 'vip') ad = 'dilediğin ürün %' + st.next.yuzde;
    else ad = st.next.etiket === '_kc_gift2' ? 'sürpriz hediye' : 'hediyen';
    return 'Sıradaki durak: <b>' + ad + ' — ' + tl(st.next.esik - st.qualifying) + ' sonra.</b>';
  }

  function maybeToast(cart) {
    var st = analyze(cart);
    var key = st.unlocked + '|' + st.activeYuzde;

    if (lastTierKey === null) {
      // İlk gözlem: hak edilmiş kazançla dönen müşteriyi SESSİZ geçme —
      // ama SEANSTA 1 KEZ. lastTierKey her sayfa yüklemesinde sıfırlanır;
      // guard'sız hali her navigasyonda "Hoş geldin" atıyordu (03.08 fix).
      lastTierKey = key;
      if (st.kazanc > 0 && !sessionStorage.getItem('kck_welcome')) {
        sessionStorage.setItem('kck_welcome', '1');
        showToast('welcome', 'Hoş geldin.', tl(st.kazanc), 'Kazancın hazır. ' + nextStopText(st), 4200);
      }
      return;
    }
    if (key === lastTierKey) return;
    var prev = parseInt(lastTierKey.split('|')[0], 10) || 0;
    lastTierKey = key;
    if (st.unlocked <= prev) return; // aşağı iniş: SESSİZ (koru çipi konuşur, toast azarlamaz)

    if (HMOD) {
      var n = 0; ['_kc_gift','_kc_gift2','_kc_gift3'].forEach(function (k) { (CFG.hediye_kademeler || []).forEach(function (h) { if (h.etiket === k && st.qualifying >= h.esik * 100) n++; }); });
      showToast(prev === 0 ? 'first' : 'repeat', '<span class="kck-serif-b">' + (n > 1 ? n + '. hediyen eklendi.' : 'Hediyen sepette.') + '</span>', tl(st.kazanc), nextStopText(st), prev === 0 ? 5000 : 3200);
      return;
    }
    if (prev === 0) {
      showToast('first', '<span class="kck-serif-b">İlk ödülün açıldı.</span>', tl(st.kazanc), nextStopText(st), 5000);
    } else if (!st.next) {
      showToast('zirve', '<span class="kck-serif-b">Zirvedesin.</span>', tl(st.kazanc), 'Son hakkın: dilediğin ürün %' + (CFG.vip ? CFG.vip.yuzde : 30) + '.', 6000);
    } else {
      showToast('repeat', (st.activeYuzde > 0 ? '%' + st.activeYuzde + ' açık.' : 'Yeni ödül açıldı.'), tl(st.kazanc), nextStopText(st), 3200);
    }
  }



  /* ===== PDP ÖDÜL PROJEKSİYONU (bundle wrap'in yerine) ===== */
  function renderPdp(cart) {
    var host = document.getElementById('kck-pdp');
    if (!host) return;
    var price = parseInt(host.getAttribute('data-price'), 10) || 0;
    var pid = parseInt(host.getAttribute('data-product-id'), 10) || 0;
    if (!price) { host.innerHTML = ''; return; }
    if (CFG.istisna_numeric && CFG.istisna_numeric.indexOf(pid) !== -1) { host.innerHTML = ''; return; }

    var st = analyze(cart);

    // "Bu ürünle X açılır" projeksiyonu kaldırıldı (03.08, Hüseyin): ürün sepete
    // girince aynı cümle "bir tane daha eklersen" anlamına kayıyor, çoklu kademe
    // atlanınca aradaki ödüller yutuluyordu. PDP artık drawer'la AYNI dili konuşur:
    // bar + rozetler = sepet gerçeği, alt satır = sıradaki ödüle kalan (footHtml).
    var nowPct = fillPctOf(st.qualifying, st.tiers);
    var miles = milesHtml(st.tiers,
      function (t) { return st.qualifying >= t.esik; },
      function (t) { return st.next && st.next.esik === t.esik && st.next.tip === t.tip; });

    host.innerHTML =
      '<div class="kck-pdp__label">Ekledikçe Kazan</div>' +
      (st.kazanc > 0 ? '<div class="kck-ldr__kaz kck-ldr__kaz--pdp"><span>' + tl(st.kazanc) + '</span><i>kazandın</i></div>' : '') +
      '<div class="kck-ldr__wrap">' + miles +
        '<div class="kck-ldr__bar"><div class="kck-ldr__fill" style="width:' + nowPct + '%"></div></div>' +
      '</div>' +
      footHtml(st) +
      (st.vipAcik ? (
        '<a href="#" class="kck-pdp__vip" id="kck-pdp-vip" data-pid="' + pid + '">' +
          '<span>Zirve hakkın: %' + CFG.vip.yuzde + ' ile ekle</span>' +
          '<span class="pz"><s>' + tl(price) + '</s><b>' + tl(Math.round(price * (100 - CFG.vip.yuzde) / 100)) + '</b></span>' +
        '</a>') : '');

    var vipBtn = document.getElementById('kck-pdp-vip');
    if (vipBtn) {
      vipBtn.addEventListener('click', function (ev) {
        ev.preventDefault();
        var form = document.querySelector('form[action*="/cart/add"] [name="id"]');
        var variantId = form ? parseInt(form.value, 10) : 0;
        if (!variantId) return;
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: [{ id: variantId, quantity: 1, properties: { _kc_vip30: '1' } }] })
        }).then(function () {
          if (window.kcCartDrawer) {
            window.kcCartDrawer.refreshFrom(null);
            if (typeof window.kcCartDrawer.open === 'function') window.kcCartDrawer.open();
          }
        });
      });
    }
  }



  /* ===== PDP HEDİYE SATIRI (Kasım 2026, kc-hediye-pdp) — sepet durumundan ===== */
  function renderHediyePdp(cart) {
    var host = document.getElementById('kchp');
    if (!host) return;
    var st = analyze(cart);
    var q = st.qualifying, n = 0;
    var esikler = (CFG.hediye_kademeler || []).map(function (h) { return h.esik * 100; }).sort(function (a, b) { return a - b; });
    esikler.forEach(function (e) { if (q >= e) n++; });
    var segs = host.querySelectorAll('[data-kchp-s]');
    segs.forEach(function (sg, i) {
      var lo = i ? esikler[i - 1] : 0, hi = esikler[i];
      var f = q >= hi ? 100 : (q <= lo ? 0 : (q - lo) / (hi - lo) * 100);
      sg.querySelector('i').style.setProperty('--f', f.toFixed(1) + '%');
      sg.classList.toggle('is-on', q >= hi);
    });
    var t = host.querySelector('[data-kchp-t]'), l2 = host.querySelector('[data-kchp-l2]');
    if (!cart.item_count || q <= 0) {
      t.textContent = '3.000 TL ve üzeri siparişe Everyday Rope Keyring';
      l2.innerHTML = 'Sepete kendiliğinden düşer, kod gerekmez';
    } else if (n >= esikler.length) {
      t.textContent = '3 keyring sepetinde';
      l2.innerHTML = 'Hediyelerin hazır';
    } else {
      t.textContent = n ? n + ' keyring sepetinde' : 'Everyday Rope Keyring hediye';
      l2.innerHTML = (n + 1) + '. keyringe <b>' + tl(esikler[n] - q) + '</b> kaldı';
    }
  }

  /* ===== FOOTER TASARRUF BLOĞU — indirim hissi ara toplamda ===== */
  function renderSavings(cart) {
    var sub = document.querySelector('.tb-sub');
    if (!sub) return;
    var old = document.getElementById('kck-sav');
    if (old) old.remove();
    var oldWas = document.getElementById('kck-sub-was');
    if (oldWas) oldWas.remove();
    if (!cart.item_count) return;

    var st = analyze(cart);
    var orderDisc = Math.round(st.qualifying * st.activeYuzde / 100);
    var giftSave = 0, vipSave = 0;
    (cart.items || []).forEach(function (i) {
      var t = lineTag(i);
      if (t === '_kc_gift' || t === '_kc_gift2' || t === '_kc_gift3') giftSave += i.original_line_price;
      else if (t === '_kc_vip30' && CFG.vip) vipSave += Math.round(i.original_line_price * CFG.vip.yuzde / 100);
    });
    var totalSave = orderDisc + giftSave + vipSave;
    if (totalSave <= 0) return;

    var rows = '';
    if (orderDisc > 0) rows += '<div class="kck-sav__row"><span>Sepet indirimi — %' + st.activeYuzde + '</span><span>−' + tl(orderDisc) + '</span></div>';
    if (giftSave > 0) rows += '<div class="kck-sav__row"><span>Hediyelerin</span><span>−' + tl(giftSave) + '</span></div>';
    if (vipSave > 0) rows += '<div class="kck-sav__row"><span>Zirve — %' + CFG.vip.yuzde + '</span><span>−' + tl(vipSave) + '</span></div>';
    rows += '<div class="kck-sav__row kck-sav__row--total"><span>Toplam kazancın</span><span>' + tl(totalSave) + '</span></div>';

    var el = document.createElement('div');
    el.id = 'kck-sav';
    el.className = 'kck-sav';
    el.innerHTML = rows;
    sub.parentNode.insertBefore(el, sub);

    var priceWrap = sub.querySelector('.tb-sub__prices');
    if (priceWrap) {
      var s = document.createElement('s');
      s.id = 'kck-sub-was';
      s.className = 'kck-sub-was';
      s.textContent = tl(cart.total_price + totalSave);
      priceWrap.insertBefore(s, priceWrap.firstChild);
    }
  }

  /* ===== CHECKOUT-INTERCEPT — eşiğe yakınsa nazik dürtme, seansta 1 kez ===== */
  function maybeIntercept(ev) {
    try {
      if (!CFG.popup || !CFG.popup.aktif) return true;
      if (document.getElementById('kck-pop-ovl')) { ev.preventDefault(); ev.stopPropagation(); return false; }
      if (CFG.popup.seans_limit !== false && sessionStorage.getItem('kck_popup')) return true;
      var cart = window.__kckLastCart;
      if (!cart || !cart.item_count) return true;
      var st = analyze(cart);
      if (!st.next) return true;
      var kalan = st.next.esik - st.qualifying;
      if (kalan > (CFG.popup.max_eksik || 600) * 100) return true;

      ev.preventDefault();
      ev.stopPropagation();
      if (CFG.popup.seans_limit !== false) sessionStorage.setItem('kck_popup', '1');

      var kazanc;
      if (st.next.tip === 'yuzde') kazanc = Math.round((st.qualifying + kalan) * st.next.yuzde / 100) - Math.round(st.qualifying * st.activeYuzde / 100);
      else kazanc = (st.next.deger || 0);
      var odulAd = st.next.tip === 'yuzde' ? '%' + st.next.yuzde + ' indirim'
                 : st.next.tip === 'vip' ? 'dilediğin ürün %' + st.next.yuzde
                 : (st.next.etiket === '_kc_gift2' ? 'sürpriz hediye' : 'hediyen');

      // 5-6 ürün: boşluğu kapatanlar önce (ucuzdan), sonra daha pahalı seçenekler
      var havuz = (CFG.kopru_urunler || []).slice().sort(function (a, b) { return a.fiyat - b.fiyat; });
      var kapatan = havuz.filter(function (u) { return u.fiyat * 100 >= kalan; });
      var kucuk = havuz.filter(function (u) { return u.fiyat * 100 < kalan; });
      var urunler = kapatan.concat(kucuk).slice(0, 6);
      var cardsHtml = urunler.map(function (u) {
        var kapat = u.fiyat * 100 >= kalan;
        return '<div class="kck-pop__card' + (kapat ? '' : ' kck-pop__card--eksik') + '" data-variant="' + u.variant + '" data-url="' + (u.url || '') + '">' +
          (kapat && u === kapatan[0] ? '<span class="kck-pop__fit">Tam oturur</span>' : '') +
          '<img src="' + u.img + '" alt="" loading="lazy">' +
          '<div class="kck-pop__cn">' + u.ad + '</div>' +
          '<div class="kck-pop__cp">' + u.fiyat + ' TL <span class="kck-pop__plus">+</span></div>' +
        '</div>';
      }).join('');

      // Drawer içinden yukarı kayan sheet — checkout akışının doğal adımı gibi
      var drawer = document.getElementById('tb-drawer') || document.body;
      var ovl = document.createElement('div');
      ovl.id = 'kck-pop-ovl';
      ovl.className = 'kck-pop-ovl';
      ovl.innerHTML =
        '<div class="kck-pop">' +
          '<div class="kck-pop__grab"></div>' +
          '<div class="kck-pop__h kck-serif">Bir adım kaldı.</div>' +
          (st.next.tip === 'yuzde' && kazanc > 0 ? '<div class="kck-pop__big">+' + tl(kazanc) + '<i>' + tl(kalan) + ' ekleyince kazancın</i></div>' : '') +
          '<div class="kck-pop__p">Sepetine <b>' + tl(kalan) + '</b> daha ekle — ' + odulAd + ' senin olsun.</div>' +
          '<div class="kck-pop__row">' + cardsHtml + '</div>' +
          '<a href="#" class="kck-pop__ghost" id="kck-pop-devam">İstersen bu adımı atla — ödemeye geç</a>' +
        '</div>';
      drawer.appendChild(ovl);
      requestAnimationFrame(function () { ovl.classList.add('is-in'); });

      // Fare tekerleği yatay kaydırmaz — dikey tekerleği ürün sırasına yönlendir
      var urunRow = ovl.querySelector('.kck-pop__row');
      if (urunRow) {
        urunRow.addEventListener('wheel', function (e) {
          if (urunRow.scrollWidth > urunRow.clientWidth && Math.abs(e.deltaY) > Math.abs(e.deltaX)) {
            urunRow.scrollLeft += e.deltaY;
            e.preventDefault();
          }
        }, { passive: false });
      }

      function kapat(cb) {
        ovl.classList.remove('is-in');
        setTimeout(function () { ovl.remove(); if (cb) cb(); }, 260);
      }
      ovl.addEventListener('click', function (e) {
        var card = e.target.closest('.kck-pop__card');
        if (card) {
          var isPlus = !!e.target.closest('.kck-pop__plus');
          var url = card.getAttribute('data-url');
          if (!isPlus && url) { window.location = url; return; }
          var vid = parseInt(card.getAttribute('data-variant'), 10);
          fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ items: [{ id: vid, quantity: 1 }] })
          }).then(function (res) {
            if (!res.ok) {
              card.classList.add('kck-pop__card--eksik');
              var cp = card.querySelector('.kck-pop__cp');
              if (cp) cp.innerHTML = '<b style="color:#c75417">Tükendi</b>';
              return;
            }
            kapat();
            if (window.kcCartDrawer) window.kcCartDrawer.refreshFrom(null);
          });
          return;
        }
        if (e.target.closest('#kck-pop-devam')) { e.preventDefault(); kapat(function () { window.location = '/checkout'; }); return; }
        if (e.target === ovl) kapat();
      });

      return false;
    } catch (err) {
      console.error('[kck] intercept', err);
      return true;
    }
  }

  function hookCheckout() {
    document.addEventListener('click', function (ev) {
      var btn = ev.target.closest('.tb-checkout');
      if (!btn) return;
      maybeIntercept(ev);
    }, true);
    // Bubble fallback: kimse engellemediyse ödemeye git (eski inline onclick'in yerine)
    document.addEventListener('click', function (ev) {
      var btn = ev.target.closest('.tb-checkout');
      if (!btn || ev.defaultPrevented) return;
      window.location = '/checkout';
    });
  }

  /* ===== SEPET DEĞİŞİMİNE BAĞLAN ===== */
  function onCart(cart) {
    try {
      window.__kckLastCart = cart;
      // VIP seçim modu bakımı: hak başka yoldan kullanıldıysa modu düşür;
      // varış sayfasında bir kez bilgi toast'ı (sayfa gezinirken susar)
      if (vipSecArmed()) {
        var stv = analyze(cart);
        if (stv.vipKullanildi) vipSecDisarm();
        else if (stv.vipAcik && !sessionStorage.getItem('kck_vip_sec_t')) {
          sessionStorage.setItem('kck_vip_sec_t', '1');
          showToast('vip', '<span class="kck-serif-b">Zirve hakkın hazır.</span>', null,
            'Şimdi sepete ekleyeceğin ilk ürün <b>%' + (CFG.vip ? CFG.vip.yuzde : 30) + ' indirimli</b> girer.', 5200);
        }
      }
      renderMeter(cart);
      var eskiVip = document.getElementById('kck-vip'); if (eskiVip) eskiVip.remove(); // Zirve kartı kaldırıldı — minimal versiyon Hüseyin'le tasarlanacak
      renderSavings(cart);
      renderPdp(cart);
      renderHediyePdp(cart);
      decorateGiftCards(cart);
      decorateKademePrices(cart);
      maybeToast(cart);
      clearTimeout(debounceTimer);
      debounceTimer = setTimeout(syncGifts, 500);
    } catch (e) {
      console.error('[kck]', e); // kampanya katmanı asla drawer'ı kırmamalı
    }
  }

  function hook() {
    var d = window.kcCartDrawer;
    if (!d) { setTimeout(hook, 150); return; }
    ['refreshFrom', 'refresh'].forEach(function (fn) {
      var orig = d[fn].bind(d);
      d[fn] = function (arg) {
        var p = orig(arg);
        Promise.resolve(p).then(function () {
          return fetch('/cart.js').then(function (r) { return r.json(); }).then(onCart);
        }).catch(function () {});
        return p;
      };
    });
    if (CFG.popup && CFG.popup.aktif) hookCheckout();
    hookRenkSwatch();
    if (CFG.vip) hookVipSec();
    // Yatay döndürme / pencere boyutu değişince meter doğru varyanta geçsin
    var mq = window.matchMedia('(max-width: 640px)');
    var mqCb = function () { if (window.__kckLastCart) renderMeter(window.__kckLastCart); };
    if (mq.addEventListener) mq.addEventListener('change', mqCb);
    else if (mq.addListener) mq.addListener(mqCb);
    fetch('/cart.js').then(function (r) { return r.json(); }).then(onCart).catch(function () {});
    // Watchdog: debounce zinciri hangi sebeple boğulursa boğulsun, hediye durumu
    // en geç 4 sn'de kendini onarır (syncGifts idempotent — taze sepetten plan kurar)
    setInterval(function () {
      if (document.visibilityState !== 'visible' || busy) return;
      syncGifts();
    }, 4000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', hook);
  } else {
    hook();
  }
})();
